import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalSettingsStores from '../../../../../../stores/settings-stores';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';

export const deleteQuestionOperation = async (
  pollId: number,
  questionId: number,
  setLoading: (isLoading: boolean) => void,
  onSuccess: () => void,
) => {
  try {
    setLoading(true);
    const res = await appApi.deletePollQuestion(pollId, questionId);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      onSuccess();
    } else {
      await globalSettingsStores.fetchSetting();
      toast.success('השאלה נמחקה בהצלחה');
      setLoading(false);
      onSuccess();
    }
  } catch (e) {
    toast.error('לא ניתן לבצע את הפעולה, נסה שוב בעוד מספר רגעים');
    setLoading(false);
  }
};
